import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="mx-auto max-w-7xl px-4 pb-16 md:px-6">
      <div className="relative overflow-hidden rounded-2xl bg-primary-500 px-6 py-12 text-center md:px-12 md:py-16">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-600/60 to-primary-500" />
        <div className="relative z-10 mx-auto flex max-w-2xl flex-col items-center">
          <h2 className="font-heading text-3xl text-background-50 md:text-4xl">立即开启你的追更之旅</h2>
          <p className="mt-3 text-sm leading-relaxed text-background-100 md:text-base">
            免费订阅漫画更新提醒，体验最新话推送与连载进度查询。追更不迷路，从今天开始。
          </p>
          <div className="mt-6 flex flex-col gap-3 sm:flex-row">
            <a
              href="#tracking"
              className="whitespace-nowrap rounded-full bg-background-50 px-7 py-3 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100"
            >
              免费开始追更
            </a>
            <Link
              to="/about"
              className="whitespace-nowrap rounded-full border border-background-50/40 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
            >
              联系我们
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}